<section class="content-header" style="padding:0.5%  !important">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-8">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item"><a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item"><a [routerLink]="['/mark']">Điểm môn học</a></li>
                    <li class="breadcrumb-item active">Điểm quá trình</li> &nbsp;
                </ol>
            </div><!-- /.col -->
            <div class="col-sm-4">
                <button (click)="ExportTOExcel()" style="float: right;;" class="btn btn-sm btn-info "><i
                        class="fas fa-file-excel"></i> Xuất Excel</button>
                <button class="btn btn-sm btn-danger" style="float: right; margin-right: 10px" (click)="KhoaDiem()"><i
                        class="fas fa-lock"></i> Khóa </button>
                <button style="float: right; margin-right: 10px;" class="btn btn-sm btn-success" (click)="Save()"><i
                        class="fas fa-save"></i> Lưu
                </button>
            </div><!-- /.col -->
        </div><!-- /.row -->
    </div><!-- /.container-fluid -->
</section>

<section class="content cus-body">
    <div class="card">
        <div class="card-body" style="padding: 0px 20px 0px 20px;">
            <div class="tab-content">
                <div class="active tab-pane">
                    <div class="row pt10">
                        <div class="col-md-7">
                            <label class="col-md-10">Môn học : {{TitleMon}}</label>
                        </div>
                        <div class="col-md-5">
                            <label class="col-md-10">Học kỳ : {{TitleHocKy}} - Năm học : {{TitleNamHoc}} </label>
                        </div>
                        <div class="col-md-12">
                            <label class="col-md-10">Lớp : {{TitleLop}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="content cus-body">
    <div class="card">
        <div class="card-body cus-body">
            <div class="tab-content">
                <div class="active tab-pane" id="TeachInfo">
                    <div class="row">
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="table-responsive dataTables_wrapper container-fluid dt-bootstrap4 cus-fs"
                                style="height: 70vh;">
                                <table
                                    class="table-bordered dataTables_wrapper no-footer table table-hover table-striped"
                                    (keydown)="onKeydown($event)" id="lstStudents"></table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.tab-content -->
        </div><!-- /.card-body -->
    </div>

    <!-- /.row -->
</section>

<section class="content-header" style="padding:0.5%  !important">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-12 text-center">
                <button (click)="ExportTOExcel()" style="float: right;" class="btn btn-sm btn-info "><i
                        class="fas fa-file-download"></i> Xuất Excel</button>
                <button class="btn btn-sm btn-danger" style="float: right; margin-right: 10px;" (click)="KhoaDiem()"><i
                        class="fas fa-lock"></i> Khóa</button>
                <button style="float: right; margin-right: 10px;" class="btn btn-sm btn-success" (click)="Save()"><i
                        class="fas fa-save"></i> Lưu
                </button>
            </div><!-- /.col -->
        </div><!-- /.row -->
    </div><!-- /.container-fluid -->
</section>